import { render } from "./LegalTermsView.vue?vue&type=template&id=1c6822b8&scoped=true"
import script from "./LegalTermsView.vue?vue&type=script&lang=js"
export * from "./LegalTermsView.vue?vue&type=script&lang=js"

import "./LegalTermsView.vue?vue&type=style&index=0&id=1c6822b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6822b8"]])

export default __exports__